import { createContext } from "react";
import { IUser } from "../../types";

interface IUserContext{
    user: IUser;
    setUser: any;
    roles: any;
    setRoles: any
}

const UserContext = createContext<IUserContext>(null!);

export default UserContext;